const Beauty = [
  {
    category: "beauty",
    subcategory: "Faux cils",
    name: "Kit de recourbe-cils Perm",
    price: "23.56",
    raw_price: "39.85",
    currency: "USD",
    discount: "41",
    likes_count: "150",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/2A/CD/57b2f490-848d-4e91-a117-d113c2654474.JPG",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/eyelashes-4382/p-1296354.html",
    id: "1296354",
    model: "SKU955160",
  },
  {
    category: "beauty",
    subcategory: "Sports Equipments",
    name:
      "Fitness Buttocks Machine Corrects Buttocks Muscles Fitness Machine Exercise Pelvic Floor Muscles Beautiful Buttocks Clip Training Buttocks",
    price: "19.99",
    raw_price: "39.99",
    currency: "USD",
    discount: "50",
    likes_count: "64",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Rose",
    variation_1_color: "Violet",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/19/7D/aec3f6cf-5301-4c28-bfc4-7d5ed27c4459.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/19/7D/aec3f6cf-5301-4c28-bfc4-7d5ed27c4459.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/8E/9F/893d392f-d031-4e7d-b69b-baee82acbef3.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/8E/9F/893d392f-d031-4e7d-b69b-baee82acbef3.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/39/04/83d4da2b-c84f-4d34-8390-4ed636f8b467.jpg",
    url: "https://fr.newchic.com/sports-equipments-9908/p-1678052.html",
    id: "1678052",
    model: "SKUF03789",
  },
  {
    category: "beauty",
    subcategory: "Autres produits des soins personnels",
    name: "Oxymètre de pouls portable à pince",
    price: "39.99",
    raw_price: "79.99",
    currency: "USD",
    discount: "50",
    likes_count: "113",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/09/38/ad1da1ed-d3a4-42ad-a418-87f50607ec46.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url:
      "https://fr.newchic.com/other-personal-care-products-5723/p-1530616.html",
    id: "1530616",
    model: "SKUC51442",
  },
  {
    category: "beauty",
    subcategory: "Kit de l'art pour ongles",
    name: "Set Nail Art",
    price: "48.35",
    raw_price: "77.86",
    currency: "USD",
    discount: "38",
    likes_count: "1186",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "PH,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/78/52/8b42497a-b124-4e4d-b4b8-864a9671140d.JPG",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/nail-art-set-4363/p-1076402.html",
    id: "1076402",
    model: "SKU418150",
  },
  {
    category: "beauty",
    subcategory: "Soins des pieds",
    name: "Dispositif de correction Hallux Valgus en silicone",
    price: "11.99",
    raw_price: "24.35",
    currency: "USD",
    discount: "51",
    likes_count: "149",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F6/3F/4bc750f8-cdff-4c22-8d34-5a0609147cb2.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/foot-care-4330/p-1200340.html",
    id: "1200340",
    model: "SKU764891",
  },
  {
    category: "beauty",
    subcategory: "Fers à friser pour cheveux",
    name: "Fer à friser professionnel",
    price: "38.51",
    raw_price: "66.99",
    currency: "USD",
    discount: "43",
    likes_count: "140",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Or rose",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/EC/2A/afe56cd4-1713-438a-9049-2f6dc74d6a4c.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/EC/2A/afe56cd4-1713-438a-9049-2f6dc74d6a4c.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A0/FF/06900858-4170-4ad2-9af9-2a093664c609.jpg",
    url: "https://fr.newchic.com/hair-curlers-4483/p-1663599.html",
    id: "1663599",
    model: "SKUE97846",
  },
  {
    category: "beauty",
    subcategory: "Kit de l'art pour ongles",
    name: "Ensemble de machines de photothérapie",
    price: "11.49",
    raw_price: "19.99",
    currency: "USD",
    discount: "43",
    likes_count: "169",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/32/FB/d7f0e76f-669f-4c43-adcf-4c036254a918.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/nail-art-set-4363/p-1667767.html",
    id: "1667767",
    model: "SKUE78590",
  },
  {
    category: "beauty",
    subcategory: "Épilateur",
    name: "Épilateur laser permanent professionnel",
    price: "79.99",
    raw_price: "141.98",
    currency: "USD",
    discount: "44",
    likes_count: "53",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "White",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/05/81/02a8ebce-1565-47e3-a57e-d53580c16a97.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/05/81/02a8ebce-1565-47e3-a57e-d53580c16a97.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D7/97/f24f2ef8-bd90-4f55-b81f-d2f4a7dfde53.jpg",
    url: "https://fr.newchic.com/epilator-4898/p-1695686.html",
    id: "1695686",
    model: "SKUF44536",
  },
  {
    category: "beauty",
    subcategory: "Massage & Relaxation",
    name: "Masseur relaxant musculaire ",
    price: "97.74",
    raw_price: "159.37",
    currency: "USD",
    discount: "39",
    likes_count: "121",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Blue",
    variation_1_color: "Red",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/C6/B4/a0aa17a6-4657-4a89-b3ee-a422d62415aa.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/C6/B4/a0aa17a6-4657-4a89-b3ee-a422d62415aa.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/A3/FB/d6b5693b-53f4-4af2-a820-73a6332ce1de.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/A3/FB/d6b5693b-53f4-4af2-a820-73a6332ce1de.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/33/95/6bd60d79-7665-4de9-a0a6-7709c34aff65.jpg",
    url: "https://fr.newchic.com/massager-and-relaxing-5725/p-1564336.html",
    id: "1564336",
    model: "SKUD40912",
  },
  {
    category: "beauty",
    subcategory: "Sports Equipments",
    name: "Vélo électrique pliant",
    price: "1899.99",
    raw_price: "3999.99",
    currency: "USD",
    discount: "53",
    likes_count: "8",
    is_new: "false",
    brand: "Fiido",
    brand_url: "https://fr.newchic.com/fiido-brand-1753.html",
    codCountry: "SG,VN",
    variation_0_color: "Black",
    variation_1_color: "White",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/1A/02/5a2a1273-c3b5-480b-bc68-27410cc455d6.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/1A/02/5a2a1273-c3b5-480b-bc68-27410cc455d6.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/2C/C2/a2608dea-559c-452e-85ee-9f5eb52d3968.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/2C/C2/a2608dea-559c-452e-85ee-9f5eb52d3968.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F4/5A/905d5244-21d7-4f5c-96b1-cd20cce06eed.jpg",
    url: "https://fr.newchic.com/fiido-sports-equipments-9908/p-1687595.html",
    id: "1687595",
    model: "SKUF20759",
  },
  {
    category: "beauty",
    subcategory: "Vernis à ongles",
    name: "Stylo vernis à ongles en gel",
    price: "10.34",
    raw_price: "16.99",
    currency: "USD",
    discount: "39",
    likes_count: "123",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/29/B8/330d6b86-dd09-45b8-aff0-41297a60ddaf.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/nail-gel-and-polish-4355/p-1667772.html",
    id: "1667772",
    model: "SKUE99065",
  },
  {
    category: "beauty",
    subcategory: "Épilateur",
    name: "Ensemble de chauffe-cire électrique",
    price: "64.99",
    raw_price: "129.99",
    currency: "USD",
    discount: "50",
    likes_count: "80",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Purple",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/DD/14/b04221cd-d4b2-4615-8a3d-f1b880dd248f.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DD/14/b04221cd-d4b2-4615-8a3d-f1b880dd248f.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A4/00/3ae50af1-aa6c-4474-8585-11810ebfb336.jpg",
    url: "https://fr.newchic.com/epilator-4898/p-1659987.html",
    id: "1659987",
    model: "SKUE81601",
  },
  {
    category: "beauty",
    subcategory: "Huile essentielle",
    name: "Huile essentielle de chanvre pur ",
    price: "13.79",
    raw_price: "23.99",
    currency: "USD",
    discount: "43",
    likes_count: "53",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/29/69/8c6ffdaf-218c-4e23-b495-cdccc4889feb.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/essential-oil-4329/p-1634735.html",
    id: "1634735",
    model: "SKUC92514",
  },
  {
    category: "beauty",
    subcategory: "Crayon à sourcils & Amplificateur",
    name: "Kit de lifting des sourcils semi-pernament",
    price: "22.99",
    raw_price: "0",
    currency: "USD",
    discount: "0",
    likes_count: "36",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/29/DA/ae21b984-4ed6-4736-b63c-7d5467c0c93b.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url:
      "https://fr.newchic.com/eyebrow-pencil-and-enhancers-4383/p-1685811.html",
    id: "1685811",
    model: "SKUF30584",
  },
  {
    category: "beauty",
    subcategory: "Soins des pieds",
    name: "Broyeur électrique de dossier de pied",
    price: "27.99",
    raw_price: "59.99",
    currency: "USD",
    discount: "53",
    likes_count: "74",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E3/47/910ca18f-b650-4805-91f1-d37f11421d0b.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/foot-care-4330/p-1685380.html",
    id: "1685380",
    model: "SKUF32514",
  },
  {
    category: "beauty",
    subcategory: "Daily Necessities",
    name: "20pcs / boîtes de papier portable pour le lavage des mains ",
    price: "6.31",
    raw_price: "10.99",
    currency: "USD",
    discount: "43",
    likes_count: "463",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/30/D0/9625edb4-f3f1-4048-b605-92c9b939eae2.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/daily-necessities-9872/p-1652305.html",
    id: "1652305",
    model: "SKUE79358",
  },
  {
    category: "beauty",
    subcategory: "Tondeuse pour poils",
    name: "Ensemble de tondeuse à cheveux électrique",
    price: "63.24",
    raw_price: "109.99",
    currency: "USD",
    discount: "43",
    likes_count: "14",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Gold",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/1E/A2/e17627db-0628-4276-a533-9ddb160d88cb.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/1E/A2/e17627db-0628-4276-a533-9ddb160d88cb.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/hair-trimmer-4901/p-1669009.html",
    id: "1669009",
    model: "SKUE99641",
  },
  {
    category: "beauty",
    subcategory: "Health Care",
    name: "50 masques faciaux jetables",
    price: "19.99",
    raw_price: "42.99",
    currency: "USD",
    discount: "54",
    likes_count: "467",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5D/5F/693ec4db-5cce-4c42-a7b8-28c9a2d404df.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/health-care-9871/p-1643997.html",
    id: "1643997",
    model: "SKUE63694",
  },
  {
    category: "beauty",
    subcategory: "Massage & Relaxation",
    name: "Massage cervical électrique à 15 vitesses",
    price: "49.99",
    raw_price: "0",
    currency: "USD",
    discount: "0",
    likes_count: "60",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/8B/4C/7bd525a4-2d01-4e70-9263-eb45c0618393.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/massager-and-relaxing-5725/p-1664737.html",
    id: "1664737",
    model: "SKUE24759",
  },
  {
    category: "beauty",
    subcategory: "Health Care",
    name:
      "10PCS 3 couches de masque facial de bactéries filtrantes non tissées",
    price: "5.99",
    raw_price: "10.99",
    currency: "USD",
    discount: "46",
    likes_count: "322",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#01",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C7/3B/4a23cad4-039c-40ee-a922-33e98dddd808.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C7/3B/4a23cad4-039c-40ee-a922-33e98dddd808.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/health-care-9871/p-1662068.html",
    id: "1662068",
    model: "SKUE94244",
  },
  {
    category: "beauty",
    subcategory: "Sports Equipments",
    name: "Barres d'acier horizontales de porte ",
    price: "59.99",
    raw_price: "119.99",
    currency: "USD",
    discount: "50",
    likes_count: "20",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Blue",
    variation_1_color: "Red",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/1C/40/2016f8d3-0050-47fb-9e1f-8bfa33b4b4b1.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/1C/40/2016f8d3-0050-47fb-9e1f-8bfa33b4b4b1.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/82/5D/fd719696-14f4-4dd8-be24-daf8624134e3.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/82/5D/fd719696-14f4-4dd8-be24-daf8624134e3.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/77/ED/173911cf-f938-4300-88f5-1d0afa7eeb63.jpg",
    url: "https://fr.newchic.com/sports-equipments-9908/p-1676820.html",
    id: "1676820",
    model: "SKUF12319",
  },
  {
    category: "beauty",
    subcategory: "Tondeuse pour poils",
    name: "Ensemble de coupe-cheveux multifonctionnel ",
    price: "25.86",
    raw_price: "44.99",
    currency: "USD",
    discount: "43",
    likes_count: "142",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/4B/C6/e68df5fb-5c0a-429c-ba00-f7c23bd393d6.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/hair-trimmer-4901/p-1315219.html",
    id: "1315219",
    model: "SKU985595",
  },
  {
    category: "beauty",
    subcategory: "Vêtements minceur",
    name: "Ceinture de correction du dos",
    price: "17.81",
    raw_price: "29.8",
    currency: "USD",
    discount: "40",
    likes_count: "90",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/BD/AC/9a6ce0e1-dc4a-4a25-9261-24c292d0f42b.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BD/AC/9a6ce0e1-dc4a-4a25-9261-24c292d0f42b.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D9/C7/74cb5d67-c1d9-457d-905e-e41324209f74.jpg",
    url: "https://fr.newchic.com/body-shaping-5724/p-1651622.html",
    id: "1651622",
    model: "SKUE76715",
  },
  {
    category: "beauty",
    subcategory: "Daily Necessities",
    name: "Coussin hygiénique lavable ",
    price: "7.46",
    raw_price: "12.99",
    currency: "USD",
    discount: "43",
    likes_count: "49",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E2/69/92875bdf-7b97-46c8-bb65-cdeadc8cb191.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/daily-necessities-9872/p-1652030.html",
    id: "1652030",
    model: "SKUE77787",
  },
  {
    category: "beauty",
    subcategory: "Perruques synthétiques",
    name: "Perruques bouclées longues de 28 pouces",
    price: "41.99",
    raw_price: "82.99",
    currency: "USD",
    discount: "49",
    likes_count: "32",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Brown",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/B0/C8/82e7ce87-3f3f-4d8c-95ed-6db15c6fe76d.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B0/C8/82e7ce87-3f3f-4d8c-95ed-6db15c6fe76d.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/synthetic-wigs-4150/p-1683629.html",
    id: "1683629",
    model: "SKUF29451",
  },
  {
    category: "beauty",
    subcategory: "Miroirs",
    name: "Anneau lumineux de 10 pouces LED",
    price: "21.99",
    raw_price: "42.99",
    currency: "USD",
    discount: "49",
    likes_count: "38",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D6/49/31e9e172-5e09-488e-bbd6-8b05c9d7cdb7.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/mirrors-4034/p-1634939.html",
    id: "1634939",
    model: "SKUE31382",
  },
  {
    category: "beauty",
    subcategory: "Gloss à lèvres",
    name: "Missyoung Gloss Mat Sexy Brillant à Lèvres Liquide",
    price: "9.88",
    raw_price: "17.18",
    currency: "USD",
    discount: "43",
    likes_count: "6962",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "",
    variation_0_color: "# 12",
    variation_1_color: "dix#",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/EC/62/e5d8ab82-3d0d-4605-bb19-1d690fde7cd5.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/EC/62/e5d8ab82-3d0d-4605-bb19-1d690fde7cd5.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/65/DB/2fee0c2a-7eaa-4a33-a619-95f70407b1cf.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/65/DB/2fee0c2a-7eaa-4a33-a619-95f70407b1cf.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/2C/4B/381db894-5259-440c-a317-f455ea17b190.jpg",
    url: "https://fr.newchic.com/lip-gloss-4367/p-1164687.html",
    id: "1164687",
    model: "SKU692692",
  },
  {
    category: "beauty",
    subcategory: "Ciseaux & Cisailles de coiffure",
    name: "Ensemble d'outils de coupe de cheveux",
    price: "39.99",
    raw_price: "79.99",
    currency: "USD",
    discount: "50",
    likes_count: "98",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "",
    variation_0_color: "Silver",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/AC/5D/e420a5da-96e6-4ba8-8839-fe1556eda43b.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/AC/5D/e420a5da-96e6-4ba8-8839-fe1556eda43b.jpeg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/hair-scissors-and-shears-4485/p-1663557.html",
    id: "1663557",
    model: "SKUE95712",
  },
  {
    category: "beauty",
    subcategory: "Daily Necessities",
    name: "Lingettes humides Mini Barrels ",
    price: "6.31",
    raw_price: "10.99",
    currency: "USD",
    discount: "43",
    likes_count: "50",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/14/7D/552f79f1-4d66-4734-9090-bf119c8d9ed2.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/daily-necessities-9872/p-1665569.html",
    id: "1665569",
    model: "SKUE95884",
  },
  {
    category: "beauty",
    subcategory: "Sports Equipments",
    name: "Protection du genou Booster ",
    price: "51.74",
    raw_price: "179.99",
    currency: "USD",
    discount: "71",
    likes_count: "97",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/64/6D/9f9be192-18ae-4639-a7db-a09b175ce0c9.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/64/6D/9f9be192-18ae-4639-a7db-a09b175ce0c9.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/7E/59/32717db2-261b-4ed7-81bd-e636d88d9cf5.jpg",
    url: "https://fr.newchic.com/sports-equipments-9908/p-1558067.html",
    id: "1558067",
    model: "SKUD38246",
  },
  {
    category: "beauty",
    subcategory: "Miroirs",
    name: "Anneau lumineux USB",
    price: "11.99",
    raw_price: "22",
    currency: "USD",
    discount: "46",
    likes_count: "63",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0D/9E/c89f9b4b-273b-4a39-9f97-b50071a70b4f.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/mirrors-4034/p-1690464.html",
    id: "1690464",
    model: "SKUF28091",
  },
  {
    category: "beauty",
    subcategory: "Daily Necessities",
    name: "Lingettes humides à 70% d'alcool ",
    price: "10.34",
    raw_price: "16.71",
    currency: "USD",
    discount: "38",
    likes_count: "68",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B7/CB/d507e760-e34c-4baa-ad22-7c7821b2fb81.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/daily-necessities-9872/p-1650270.html",
    id: "1650270",
    model: "SKUE76060",
  },
  {
    category: "beauty",
    subcategory: "Kit de l'art pour ongles",
    name:
      "220V 36W Nail Art Set UV Kit de bouts de lime à cuticules pour lampe gel",
    price: "71.16",
    raw_price: "112.53",
    currency: "USD",
    discount: "37",
    likes_count: "197",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/4D/A6/db3571c9-5142-b7a1-699d-9516deedc343.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/nail-art-set-4363/p-971648.html",
    id: "971648",
    model: "SKU177056",
  },
  {
    category: "beauty",
    subcategory: "Accessoires soin visage",
    name: "Machine professionnelle de masque facial de photon",
    price: "95.99",
    raw_price: "0",
    currency: "USD",
    discount: "0",
    likes_count: "24",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "blanc",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/66/C3/0b66b805-0293-4b33-8361-42170351756f.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/66/C3/0b66b805-0293-4b33-8361-42170351756f.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D7/C0/1a33409d-ee09-4e5f-87f9-ed174bb1d2bc.jpg",
    url: "https://fr.newchic.com/face-care-tools-5532/p-1696871.html",
    id: "1696871",
    model: "SKUF50272",
  },
  {
    category: "beauty",
    subcategory: "Épilateur",
    name: "Kit de cire pour épilation",
    price: "44.99",
    raw_price: "89.99",
    currency: "USD",
    discount: "50",
    likes_count: "15",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "PH,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D7/66/91c61cb1-4143-4c33-88c8-517f369540ba.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/epilator-4898/p-1693515.html",
    id: "1693515",
    model: "SKUF40270",
  },
  {
    category: "beauty",
    subcategory: "Health Care",
    name: "20pcs masques jetables ",
    price: "27.59",
    raw_price: "58.21",
    currency: "USD",
    discount: "53",
    likes_count: "1392",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F6/73/06cbc32e-b06e-43bd-82c0-139daadd9102.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/health-care-9871/p-1643183.html",
    id: "1643183",
    model: "SKUE62386",
  },
  {
    category: "beauty",
    subcategory: "Kit de l'art pour ongles",
    name: "Kit de gel d'extension d'ongle",
    price: "40.99",
    raw_price: "81.98",
    currency: "USD",
    discount: "50",
    likes_count: "16",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D0/65/39052b42-bfee-479c-9aee-a1ce234e6296.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/nail-art-set-4363/p-1700974.html",
    id: "1700974",
    model: "SKUF24011",
  },
  {
    category: "beauty",
    subcategory: "Daily Necessities",
    name: "Papier de savon pour les mains grenouille",
    price: "10.34",
    raw_price: "16.71",
    currency: "USD",
    discount: "38",
    likes_count: "158",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "Pink",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6D/B4/b00b2835-0a7e-4a3f-9622-69a1b02f9a4a.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6D/B4/b00b2835-0a7e-4a3f-9622-69a1b02f9a4a.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/D7/EF/ffd4b8a7-f8e0-4f24-9ec7-b77a7301c4de.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D7/EF/ffd4b8a7-f8e0-4f24-9ec7-b77a7301c4de.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E6/5C/b4570dc4-54da-440b-b653-2f4134d0989a.jpg",
    url: "https://fr.newchic.com/daily-necessities-9872/p-1658370.html",
    id: "1658370",
    model: "SKUE88671",
  },
  {
    category: "beauty",
    subcategory: "Health Care",
    name: "Masque facial transparent",
    price: "7.46",
    raw_price: "12.99",
    currency: "USD",
    discount: "43",
    likes_count: "308",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/13/6D/de4c1ee5-19c7-45de-895b-f60337494500.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/health-care-9871/p-1642369.html",
    id: "1642369",
    model: "SKUE60084",
  },
  {
    category: "beauty",
    subcategory: "Perruques synthétiques",
    name: "Perruques droites courtes 10 pouces",
    price: "40.99",
    raw_price: "80.99",
    currency: "USD",
    discount: "49",
    likes_count: "25",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/77/CD/5b6131cd-4c93-49dc-a379-b9056a0e1778.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/synthetic-wigs-4150/p-1686866.html",
    id: "1686866",
    model: "SKUF29505",
  },
  {
    category: "beauty",
    subcategory: "Miroirs",
    name: "10 pouces dimmable LED anneau lumineux",
    price: "29.99",
    raw_price: "61.99",
    currency: "USD",
    discount: "52",
    likes_count: "51",
    is_new: "false",
    brand: "BlitzWolf",
    brand_url: "https://fr.newchic.com/blitzwolf-brand-21.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6E/B3/bcd8bbec-09ac-4842-9eb3-aa190d37d959.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6E/B3/bcd8bbec-09ac-4842-9eb3-aa190d37d959.jpeg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "1",
    url: "https://fr.newchic.com/blitzwolf-mirrors-4034/p-1624100.html",
    id: "1624100",
    model: "SKUE04615",
  },
  {
    category: "beauty",
    subcategory: "Tondeuse pour poils",
    name: "LCD Tondeuse à cheveux avec affichage ",
    price: "43.69",
    raw_price: "75.99",
    currency: "USD",
    discount: "43",
    likes_count: "62",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "White",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/8B/6F/043d0171-182e-4683-9792-1ba149caf645.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/8B/6F/043d0171-182e-4683-9792-1ba149caf645.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/hair-trimmer-4901/p-1666374.html",
    id: "1666374",
    model: "SKUF01012",
  },
];

export default Beauty;
